var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",attrs:{"id":"container"}},[_c('ins-banner',{attrs:{"page":'Home',"initSwiper":true}}),_c('ins-fun'),_c('ins-feature'),_c('div',{staticClass:"info"},[_c('ins-facebook'),_c('ins-news')],1),_c('ins-home-rnp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }